import {combineReducers} from 'redux';
import authReducer from './authReducer';
import leaderBoardReducer from './leaderBoardReducer';
import returnsToTestReducer from './returnsToTestReducer';
import systemMetricReducer from './systemMetricsReducer';
import wordBankReducer from './wordBankReducer';
import wordPacketReducer from './wordPacketReducer';



export default combineReducers({
    auth: authReducer,
    wordPacket: wordPacketReducer,
    returnsToTest: returnsToTestReducer,
    systemMetrics: systemMetricReducer,
    userWordBank: wordBankReducer,
    leaderBoard: leaderBoardReducer,
});